import * as E from 'fp-ts/Either';
import { config } from '../config';
import {
  insertItem,
  page as commonPage,
  removeItem,
  singleItem,
  updateItem,
  ErrorResponse,
} from './common';

export type ApiKey = {
  _id: string;
  userKey: string;
  scope: string;
  organisation: string;
  contact: string;
  createdAt: string;
  updatedAt: string;
  deletedAt?: string;
};

export const page = commonPage<ApiKey>(`${config.apiUrl}/cms/v1/api-keys`);

export const remove = removeItem(`${config.apiUrl}/cms/v1/api-keys`);

export const single = singleItem<ApiKey>(`${config.apiUrl}/cms/v1/api-keys`);

export const insert = insertItem<ApiKey>(`${config.apiUrl}/cms/v1/api-keys`);

export const update = updateItem<ApiKey>(`${config.apiUrl}/cms/v1/api-keys`);

export const enumerateOrgs = async (
  token: string
): Promise<E.Either<ErrorResponse, string[]>> => {
  const response = await fetch(
    `${config.apiUrl}/cms/v1/api-keys/organisations`,
    { headers: { Authorization: `Bearer ${token}` } }
  );

  const data = await response.json();

  return response.ok ? E.right(data) : E.left(data);
};
